export default __webpack_public_path__ + "664edd396843a8897813c91050ad97f8.png";